import { Component } from "react";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("React Error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-white p-6">
                    <div className="text-center max-w-md">
                        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-red-600 text-xl font-bold">!</span>
                        </div>
                        <h2 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                            Ceva a mers greșit
                        </h2>
                        <p className="text-sm text-gray-500 mb-4">
                            {this.state.error?.message || "A apărut o eroare neașteptată."}
                        </p>
                        <button
                            onClick={() => window.location.href = "/"}
                            className="bg-[#002FA7] text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#002482] transition-colors"
                        >
                            Reîncarcă aplicația
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
